import { BehaviorSubject } from 'rxjs'
import { APIURLS } from '../../constants/ApiUrls'
import { HTTPService } from '../http-service/http-service'
import { login } from '../../schemas/auth'
import jwt_decode from 'jwt-decode';
import { connectionsModel } from '../connections-service/connections.models';



export const AuthService = {
  sideNavCollapse: new BehaviorSubject<any>(false),
  userInfo: new BehaviorSubject<any>({}),
  login: async (data: login) => {
    try {
      const response = await HTTPService.postRequest(APIURLS.LOGIN, data)
      // console.log("response",response)
      const decodedToken: any = jwt_decode(response.data.token);
      localStorage.setItem('id',response?.data?.id)
      localStorage.setItem('userid',decodedToken.userId)
      return response
    } catch (error) {
      return error
    }
  },

  getProfile: async (payload: any) => {
    try {
      const response = await HTTPService.getRequest(
        `${APIURLS.profiledata}/${payload}`
      );
      console.log("resposahil",response?.data?.users)
      // const val=connectionsModel.modifyConnectionsList(response?.data?.users);
      return response?.data?.users;
    } catch (error) {
      return { hasError: true};
    }
  },
  ssologin: async (payload: any) => {
    try {
      const response = await HTTPService.postRequest(APIURLS.SSOLOGIN,payload);
      return response;
    } catch (error) {
      return { hasError: true};
    }
  },

}
